<template>
  <Modal v-model="batchAssociationModal" :title="batchAssociationTitle" width="600" :transfer="false"
    class-name="commonModalStyles" :mask-closable="false" @on-visible-change="batchAssociationChange">
    <!--关联合规责任人-->
    <template v-if="batchAssociationType === 'personInCharge'">
      <div class="flex align-items-center">
        <span>{{ $t('key1001266') }}</span>
        <RadioGroup v-model="zoneCode">
          <Radio style="margin-right: 20px;" v-for="item in responsibleAreaList" :label="item.zoneCode">{{ item.name }}</Radio>
        </RadioGroup>
      </div>
      <h3 class="mt10 color-999 font-size-13 mb10">{{ $t('key1001267') }}</h3>
      <p class="distributorThemeColor mb10">{{ personInChargeTitle }}</p>
      <div class="flex align-items-center">
        <p class="red-dot">{{ personInChargeText }}</p>
        <Select v-model="ymsCompliancePersonId" style="width:250px;">
          <Option v-for="item in personInChargeData" :value="item.ymsCompliancePersonId">{{ item.name }}</Option>
        </Select>
      </div>
    </template>
    <!--关联制造商-->
    <template v-else>
      <div class="flex align-items-center">
        <span>{{ $t('key1001266') }}</span>
        <CheckboxGroup v-model="zoneCodes">
          <Checkbox v-for="item in responsibleAreaList" :label="item.zoneCode" style="margin-right: 20px;"
            :disabled="zoneCodes.includes(item.zoneCode) && zoneCodes.length <=1">
            {{ item.name }}
          </Checkbox>
        </CheckboxGroup>
      </div>
      <h3 class="mt10 color-999 font-size-13 mb10">{{ $t('key1001268') }}</h3>
      <p class="distributorThemeColor mb10">{{ manufacturerTitle }}</p>
      <div class="flex align-items-center">
        <p class="red-dot">{{ $t('key1001269') }}</p>
        <Select v-model="ymsManufacturerInfoId" style="width:250px;">
          <Option v-for="item in manufacturerData" :value="item.ymsManufacturerInfoId">{{ item.name }}</Option>
        </Select>
      </div>
    </template>
    <template #footer>
      <Button class="mr15" @click="batchAssociationModal = false">{{ $t('key1000112') }}</Button>
      <Button class="mr15" type="primary" @click="batchAssociationBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getAllPersonInChargeData, getCountryZoneData, getAllManufacturerData} from "@/utils/common";

export default {
  name: 'batchAssociationModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      batchAssociationModal: false,
      batchAssociationTitle: '',
      batchAssociationType: null,
      responsibleAreaList: [],
      zoneCode: 'EU',
      personInChargeList: [],
      ymsCompliancePersonId: null,
      ymsProductIds: [],
      zoneCodes: [],
      ymsManufacturerInfoId: null,
      manufacturerData: [],
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    personInChargeTitle() {
      const regionText = this.zoneCode === 'EU' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001257') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001258');
      return `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001253')}${regionText}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001254')}`;
    },
    manufacturerTitle() {
      const zoneText = this.zoneCodes.length > 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001259') : this.zoneCodes.includes('EU') ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001257') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001258');
      return `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001255')}${zoneText}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001256')}`;
    },
    personInChargeText() {
      return this.zoneCode === 'EU' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001260') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001261');
    },
    personInChargeData() {
      return this.personInChargeList.filter(item => {
        return item.zoneCode === this.zoneCode;
      });
    }
  },
  methods: {
    // 初始化数据
    initBatchAssociationData(type, ymsProductIds) {
      this.ymsProductIds = ymsProductIds;
      getCountryZoneData().then((data) => {
        this.responsibleAreaList = data;
        this.batchAssociationType = type;
        if (type === 'personInCharge') {
          this.zoneCode = 'EU';
          this.batchAssociationTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001262');
          getAllPersonInChargeData().then((data) => {
            this.personInChargeList = data;
          });
        } else {
          this.zoneCodes = data.map(item => item.zoneCode);
          this.batchAssociationTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001263');
          getAllManufacturerData().then((data) => {
            this.manufacturerData = data;
          });
        }
        this.batchAssociationModal = true;
      });
    },
    // 确定按钮
    batchAssociationBtn() {
      let list = [];
      switch (this.batchAssociationType) {
        case 'personInCharge':
          this.ymsProductIds.forEach(val => {
            list.push({
              ymsProductId: val,
              ymsCompliancePersonId: this.ymsCompliancePersonId,
              zoneCode: this.zoneCode,
              ymsDistributorMerchantId: this.userInfo.merchantId
            });
          });
          if (this.ymsCompliancePersonId) {
            this.axios.post(api.post_ymsDistributorProductInfo_insertCompliancePersonProducts,
              list, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000280'));
                this.batchAssociationModal = false;
                this.$emit('updateData', true);
              }
            });
          } else {
            this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001264'));
            return false;
          }
          break;
        case 'manufacturer':
          if (!this.ymsManufacturerInfoId) {
            this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001265'));
            return false;
          }
          this.ymsProductIds.forEach(productId => {
            this.zoneCodes.forEach(zone => {
              list.push({
                ymsProductId: productId,
                ymsManufacturerInfoId: this.ymsManufacturerInfoId,
                zoneCode: zone,
                ymsDistributorMerchantId: this.userInfo.merchantId
              });
            });
          });
          if (list.length > 0) {
            this.axios.post(api.post_ymsDistributorProductInfo_insertManufacturerProduct, list, {
              loading: true,
              loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')
            }).then(response => {
              if (response.data.code === 0) {
                this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000280'));
                this.batchAssociationModal = false;
                this.$emit('updateData', true);
              }
            });
          }
          break;
      }
    },
    // 监听弹窗
    batchAssociationChange(value) {
      if (!value) {
        this.personInChargeList = [];
        this.responsibleAreaList = [];
        this.manufacturerData = [];
        this.ymsCompliancePersonId = null;
        this.zoneCode = 'EU';
        this.ymsProductIds = [];
        this.zoneCodes = [];
        this.ymsManufacturerInfoId = null;
      }
    }
  }
};
</script>

<style lang="less">

</style>
